<template>
  <div :class="$style.sideBySide">
    <slot />
  </div>
</template>

<style module lang="scss">
.sideBySide {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  flex-direction: column;
  & + & {
    margin-top: 1.25rem;
  }
  & > * {
    flex: 1;
    margin-top: 0 !important;
  }
  @media (min-width: 768px) {
    flex-direction: row;
  }
}
</style>
